<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <div
    class="flex flex-col space-y-4 items-stretch justify-start"
    [formGroup]="form"
  >
    <mat-form-field *ngIf="freeText">
      <mat-label>Description</mat-label>
      <input
        matInput
        formControlName="freetext_description"
        data-cy="free-text-description"
        required="true"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Unit Price</mat-label>
      <span matPrefix appAddCurrencyPrefix></span>
      <input
        matInput
        formControlName="unit_price"
        data-cy="unit-price"
        required="true"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Quantity</mat-label>
      <input
        matInput
        formControlName="quantity"
        required="true"
        data-cy="quantity"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Tax rate</mat-label>
      <mat-select
        formControlName="tax_rate_type"
        required="true"
        data-cy="tax-rate"
      >
        <mat-option
          data-cy="tax-rate-option"
          *ngFor="let tax of availableTaxRates$ | async"
          [value]="tax.type"
          >{{ tax.type | taxRateName : 'sale' | async }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Serial Number</mat-label>
      <input matInput formControlName="serial_number" data-cy="serial-number" />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    (click)="save()"
    color="primary"
    [disabled]="form.invalid"
    data-cy="save-button"
  >
    Save
  </button>
</mat-dialog-actions>
